enum AntiloopVariant {
  DESKTOP = 'VariantDesktop',
  MOBILE = 'VariantMobile',
  COLORS = 'colours',
}

export default AntiloopVariant
